export const buildFieldDetailsPath = (companyId: string, propertyId: string, fieldId: string) =>
  `/company/${companyId}/property/${propertyId}/timeline/field/${fieldId}`;

export const buildTimelineFieldPath = (companyId: string, propertyId: string, fieldId: string, date?: string) => {
  const timelinePath = `/company/${companyId}/property/${propertyId}/timeline?selected=${fieldId}`;
  return date ? `${timelinePath}&start=${date}` : timelinePath;
};
